/**
 * Keyframe used to briefly highlight a row/card that was just scrolled to
 * (e.g. after "View in table" from a search result). Single source for the
 * CSS string previously duplicated verbatim in three places: PeopleTable,
 * RolesTable, and IdentityHubDashboard's org card grid.
 */
export const ROW_FLASH_STYLE_TAG =
  "@keyframes iam-row-flash{0%{background-color:color-mix(in oklch,var(--primary) 13%,transparent);}100%{background-color:transparent;}}.iam-row-flash{animation:iam-row-flash 1.4s ease-out forwards;}";
